var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsUpWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 27,
    viewBox: "0 0 28 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4035 16.0552C27.4035 15.4304 27.1961 14.8531 26.8468 14.3884C27.5447 13.8828 28 13.0619 28 12.1363C28 10.6036 26.753 9.3566 25.2202 9.3566H18.9014L19.7807 6.31909V4.86369C19.7807 2.18187 17.5989 0 14.9171 0C14.2668 0 13.7378 0.529047 13.7378 1.17928V4.40584C13.2992 5.1077 10.8639 7.84044 8.20312 10.7036V25.0585L10.4736 25.9099C11.8232 26.416 13.2383 26.6726 14.6796 26.6726H23.4306C24.9634 26.6726 26.2104 25.4255 26.2104 23.8928C26.2104 23.2683 26.0033 22.6912 25.6542 22.2265C26.352 21.721 26.8069 20.8995 26.8069 19.974C26.8069 19.3492 26.5996 18.7719 26.2503 18.3072C26.9482 17.8018 27.4035 16.9809 27.4035 16.0552Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5625 8.81592H0V26.1365H6.5625V8.81592Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpWhite);
export default __webpack_public_path__ + "static/media/thumbs-up-white.ea15710d58e22ff424cd03ed08c0f055.svg";
export { ForwardRef as ReactComponent };